export default "__VITE_ASSET__VtDAWzHK__"